import { getCartErrorMessage } from '@theme/cart-feedback';

// <s-combo-add> adds every [data-combo-variant] item to the cart in one Standard Actions update.
class SComboAdd extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-combo-add]');
      if (!button || !this.contains(button)) return;
      this.#add(button);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async #add(button) {
    if (button.getAttribute('aria-busy') === 'true') return;
    const lines = [...this.querySelectorAll('[data-combo-variant]')]
      .map((el) => ({ merchandiseId: el.dataset.comboVariant, quantity: 1 }))
      .filter((line) => line.merchandiseId);
    if (!lines.length) return;

    const error = this.querySelector('[data-combo-error]');
    if (error) error.hidden = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('opacity-70');

    try {
      if (!window.Shopify?.actions?.updateCart) throw new Error('unavailable');
      const result = await window.Shopify.actions.updateCart({ lines }, { event: { context: 'product' } });
      const message = result?.userErrors?.[0]?.message;
      if (message) throw message;
      await window.Shopify.actions.openCart?.();
    } catch (err) {
      if (error) {
        error.textContent = (typeof err === 'string' ? err : getCartErrorMessage(err)) || this.dataset.errorMessage || '';
        error.hidden = false;
      }
    } finally {
      button.removeAttribute('aria-busy');
      button.classList.remove('opacity-70');
    }
  }
}

if (!customElements.get('s-combo-add')) customElements.define('s-combo-add', SComboAdd);
